export var InsistenceType;
(function (InsistenceType) {
    InsistenceType["MadeByClient"] = "made_by_client";
    InsistenceType["MadeByFibus"] = "made_by_fibus";
})(InsistenceType || (InsistenceType = {}));
